module.exports = __webpack_public_path__ + "87b4c6b809d859e38631f10b7c18c7a0.jpg";